import { render } from "./Pictures.vue?vue&type=template&id=0d483d38&scoped=true"
import script from "./Pictures.vue?vue&type=script&lang=js"
export * from "./Pictures.vue?vue&type=script&lang=js"

import "./Pictures.vue?vue&type=style&index=0&id=0d483d38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d483d38"]])

export default __exports__